import React from "react";
import SiteUnavailableState from "./SiteUnavailableState";

interface ErrorStateProps {
  error: string;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error }) => {
  // Determine the reason based on error message
  const getReason = (): "offline" | "suspended" | "terms_violation" | "maintenance" => {
    const lowerError = error.toLowerCase();
    if (lowerError.includes("suspend")) return "suspended";
    if (lowerError.includes("terms") || lowerError.includes("violation")) return "terms_violation";
    if (lowerError.includes("maintenance")) return "maintenance";
    return "offline";
  };

  return <SiteUnavailableState reason={getReason()} customMessage={error} />;
};

export default ErrorState;